import { render, staticRenderFns } from "./rankAltTable.vue?vue&type=template&id=46775062"
import script from "./rankAltTable.vue?vue&type=script&lang=js"
export * from "./rankAltTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports